export const InovaLogoIcon = () => {
	return (
		<svg width="117" height="113" viewBox="0 0 117 113" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="29" width="30" height="29" transform="rotate(90 29 0)" fill="white" />
			<rect x="29" y="42" width="71" height="29" transform="rotate(90 29 42)" fill="white" />
			<rect x="117" width="30" height="76" transform="rotate(90 117 0)" fill="white" />
			<rect x="117" y="42" width="29" height="76" transform="rotate(90 117 42)" fill="white" />
			<rect x="117" y="83" width="30" height="76" transform="rotate(90 117 83)" fill="white" />
		</svg>
	)
}
